export default "__VITE_ASSET__HqTFovcG__"